import { FormSuccess } from '../../../components/FormSuccess'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'

export default function RefundsCompletePage() {
  return (
    <PublicFormLayout title="Solicitação de Reembolso">
      <FormSuccess
        title="Solicitação de Reembolso Concluída!"
        description="Agora é só aguardar que em até 5 dias úteis que o Setor Financeiro fará a análise e dará um retorno sobre a sua solicitação."
        notes={[
          'Em caso positivo, você receberá o seu reembolso na Chave Pix informada no formulário.',
          '1, 2, 3... ABRACEVAI'
        ]}
      />
    </PublicFormLayout>
  )
}
